module.exports = __webpack_public_path__ + "static/media/xavier_logo.c361326f.png";